import { useTheme, alpha } from "@mui/material/styles";

const customStyles = (
  color,
  backgroundColor,
  controlPadding,
  bgcolor,
  borderRadius,
  controlHeight,
  singleValueMargin
) => {
  const theme = useTheme();

  return {
    option: (styles, { isDisabled, isFocused }) => ({
      ...styles,
      backgroundColor: isFocused
        ? isDisabled
          ? theme.palette.action.disabledBackground
          : bgcolor || theme.palette.action.hover
        : theme.palette.background.paper,

      color: isDisabled
        ? theme.palette.text.disabled
        : theme.palette.text.primary,

      fontSize: "10px",
    }),

    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: theme.palette.text.primary,
      display: data.isFixed ? "none" : "flex",
    }),

    multiValueLabel: (styles) => ({
      ...styles,
      padding: 1,
    }),

    clearIndicator: (styles) => ({
      ...styles,
      padding: 4,
      color: theme.palette.text.secondary,
    }),

    control: (styles, { isDisabled }) => ({
      ...styles,

      backgroundColor: backgroundColor
        ? backgroundColor
        : isDisabled
          ? alpha(theme.palette.text.primary, 0.08)
          : theme.palette.background.paper,

      borderColor: color
        ? color
        : isDisabled
          ? alpha(theme.palette.text.primary, 0.2)
          : theme.palette.divider,

      color: theme.palette.text.primary,

      padding: controlPadding ? controlPadding : "0px 7px",

      minHeight: controlHeight ? 25 : 30,

      maxHeight: "60px",

      overflow: "hidden",

      borderRadius: borderRadius || styles.borderRadius,

      boxShadow: "none",

      "&:hover": {
        borderColor: theme.palette.secondary.main,
      },
      "&:focus-within": {
        borderColor: theme.palette.secondary.main,
        boxShadow: `0 0 0 1px ${theme.palette.secondary.main}`,
      },
    }),

    singleValue: (styles, { isDisabled }) => ({
      ...styles,

      color: isDisabled
        ? theme.palette.text.disabled
        : color || theme.palette.text.primary,

      alignItems: "center",
      marginLeft: singleValueMargin ? singleValueMargin : "2px",
      marginRight: singleValueMargin ? singleValueMargin : "2px",
    }),

    placeholder: (styles) => ({
      ...styles,
      color: theme.palette.text.secondary,
    }),

    input: (styles) => ({
      ...styles,
      color: theme.palette.text.primary,
      margin: controlHeight ? 0 : styles.margin,
    }),

    menuList: (base) => ({
      ...base,
      padding: 0,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    }),

    menu: (styles) => ({
      ...styles,
      zIndex: 999,
      marginTop: 0,
      backgroundColor: theme.palette.background.paper,
    }),

    valueContainer: (styles) => ({
      ...styles,
      padding: "0px 8px 0px 0px",
      maxHeight: "60px",
      overflowY: "auto",
      flexWrap: "wrap",
    }),

    dropdownIndicator: (styles) => ({
      ...styles,
      padding: "0px 0px 0px 5px",
      color: theme.palette.text.secondary,
    }),
  };
};

export default customStyles;